import { useEffect, useRef, useState } from 'react';
const DEFAULT_OPTIONS = {
  rootMargin: '0px 0px 400px 0px'
};
export function useInViewport(ref, options = DEFAULT_OPTIONS) {
  const [isInViewport, setIsInViewport] = useState(false);
  const optionsRef = useRef(options);
  // eslint-disable-next-line react-hooks/refs
  optionsRef.current = options;
  const activatedRef = useRef(false);
  useEffect(() => {
    const el = ref.current;
    if (!el || activatedRef.current) return;
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        activatedRef.current = true;
        setIsInViewport(true);
        observer.disconnect();
      }
    }, optionsRef.current);
    observer.observe(el);
    return () => observer.disconnect();
  }, [ref]);
  return isInViewport;
}